export default __webpack_public_path__ + "static/media/hero-banner-icon.98fe9c22.svg";